<template>
  <g
    :transform="`translate(${(position.map_x * originalImageWidth)},${(position.map_y * originalImageHeight)})`"
    :class="positionClassList"
  >
    <rect
      :id="`O-rect-${position.id}`"
      class="position"
      @click.stop="selectPosition"
      :width="width"
      :height="height"
      :rx="(position.border_radius * position.width * 100)+'%'"
    />
    <clipPath :id="`O-clip-${position.id}`">
      <use :xlink:href="`#O-rect-${position.id}`"></use>
    </clipPath>
    <svg
      :width="width"
      :height="height"
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <clipPath :id="`O-inner-clip-${position.id}`">
        <rect
          width="100"
          height="100"
          :rx="(position.border_radius * 100)+'%'"
        />
      </clipPath>
      <polygon
        class="position-inner-right-triangle"
        points="0,100 100,0 100,100"
        @click.stop="selectPosition"
        :clip-path="`url(#O-inner-clip-${position.id})`"
      />
    </svg>
    <text
      :clip-path="`url(#O-clip-${position.id})`"
      class="position-text"
      dominant-baseline="middle"
      text-anchor="middle"
      :x="(position.width * 50)+'%'"
      :y="(position.height * 53)+'%'"
    >
      <tspan
        :font-size="fontSize(position.map_name.length, position.width)"
      >
        {{ position.map_name }}
      </tspan>
    </text>
  </g>
</template>

<script>
import * as d3 from 'd3'

export default {
  name: 'MapPosition',
  props: {
    position: Object,
    selectedPositionIds: {
      type: Array,
      default: () => []
    },
    mapImageAspectRatio: Number
  },
  data: () => ({
    drag: null,
    originalImageWidth: 1000
  }),
  computed: {
    width: function () {
      return `${(this.position.width * 100)}%`
    },
    height: function () {
      return `${(this.position.height * 100)}%`
    },
    originalImageHeight: function () {
      return this.originalImageWidth * this.mapImageAspectRatio
    },
    isSelected: function () {
      return this.selectedPositionIds.includes(this.position.id)
    },
    positionClassList: function () {
      return {
        'position-container': true,
        'is-selected': this.isSelected,
        'not-selected-position': !this.isSelected
      }
    }
  },
  methods: {
    selectPosition: function () {
      this.$emit('select-position', { position: this.position })
    },
    fontSize: function (textLength, containerWidth) {
      if (textLength === 0) {
        return '0'
      }
      if (textLength === 1) {
        textLength = 1.3 // texten är ofta lite för stor när det bara är ett tecken, så gör fontsize lite mindre specifikt när det är ett tecken
      }
      let size = containerWidth * 100 / textLength * 12
      size = Math.max(Math.min(size, 16), 6)
      return `${size}px`
    },
    handleDrag: function (event) {
      this.$emit('dragged', { position: this.position, x: event.dx, y: event.dy })
    }
  },
  watch: {},
  mounted () {
    this.drag = d3.drag()
      .on('drag', this.handleDrag)

    const element = this.$el
    d3.select(element)
      .call(this.drag)
  }
}
</script>
